module.exports = __webpack_public_path__ + "img/level-4.0a7fc497.svg";